/* 数字の見せ方と、日本語入力のままでも半角にする処理（試作 v3.10 から移植。docs/10 §5.2） */

/** 表示用：−8,520（マイナスは全角の「−」） */
export const yen = (n: number): string => (n < 0 ? "−" : "") + Math.abs(Math.round(n)).toLocaleString("ja-JP");
/** 入力欄用：-8,520（マイナスは半角） */
export const yenI = (n: number): string => (n < 0 ? "-" : "") + Math.abs(Math.round(n)).toLocaleString("ja-JP");

export const toInt = (v: string | number | null | undefined): number => {
  const n = parseInt(String(v ?? "").replace(/[^\d.-]/g, ""), 10);
  return Number.isNaN(n) ? 0 : n;
};
export const toQty = (v: string | number | null | undefined): number => {
  const n = Math.round(parseFloat(String(v ?? "").replace(/[^\d.-]/g, "")) * 100) / 100;
  return Number.isNaN(n) ? 0 : n;
};
/** 数量の見せ方：整数はそのまま、小数は2桁。0 は空 */
export const fq = (n: number): string => (!n ? "" : Number.isInteger(n) ? String(n) : n.toFixed(2));

/**
 * 全角の「３２０」「１，２００」「－８５２０」を半角へ。数字・小数点・マイナス以外は捨てる。
 * ブラウザから IME は切れないので、変換確定（compositionend）の瞬間と input のたびに直す
 */
export const toHalf = (s: string, kind: "int" | "dec"): string => {
  let v = String(s)
    .normalize("NFKC")
    .replace(/[−–—ー―‐]/g, "-")
    .replace(/[，、]/g, ",")
    .replace(/[．。]/g, ".");
  v = v.replace(kind === "dec" ? /[^\d.-]/g : /[^\d,-]/g, "").replace(/(?!^)-/g, "");
  if (kind === "dec") {
    const i = v.indexOf(".");
    if (i >= 0) v = v.slice(0, i + 1) + v.slice(i + 1).replace(/\./g, "");
  }
  return v;
};

/** 'YYYY-MM-DD' → 9月13日 */
export const md = (iso: string | null | undefined): string => (iso ? `${+iso.slice(5, 7)}月${+iso.slice(8, 10)}日` : "");
/** 'YYYY-MM-DD'（日時でもよい）→ 09/13。見出しの右の状態チップ（「発行済 09/13」「期限超過 10/31」。#171、docs/10 §5.12） */
export const mdSlash = (iso: string | null | undefined): string => (iso ? `${iso.slice(5, 7)}/${iso.slice(8, 10)}` : "");

const dayDiff = (a: string, b: string) => Math.round((Date.parse(a) - Date.parse(b)) / 86_400_000);
/** 今日から見て「きょう／3日前／2週間前」 */
export const ago = (iso: string, today = todayJst()): string => {
  const d = dayDiff(today, iso);
  return d <= 0 ? "きょう" : d === 1 ? "きのう" : d < 7 ? `${d}日前` : d < 28 ? `${Math.floor(d / 7)}週間前` : `${Math.floor(d / 30)}か月前`;
};

/** 今日（日本時間）から見て何日前か（今日 − その日。未来の日は負の数）。ホームの「最長 n日経過」（#226） */
export const daysSince = (iso: string, today = todayJst()): number => dayDiff(today, iso.slice(0, 10));

/** 今日（日本時間）'YYYY-MM-DD' */
export function todayJst(): string {
  return new Date(Date.now() + 9 * 3600 * 1000).toISOString().slice(0, 10);
}
/** 日時（ISO・UTC）→ 日本時間の 'YYYY-MM-DD'（出した日時の「発行済 MM/DD」。UTC のまま切ると 0〜9時が前の日になる。#171） */
export function dayJst(iso: string): string {
  const t = Date.parse(iso);
  return Number.isNaN(t) ? iso.slice(0, 10) : new Date(t + 9 * 3600 * 1000).toISOString().slice(0, 10);
}
